import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  selectCompanyDashboard,
  getServiceIntegrations,
  setIntegrationCreatedFalse,
} from "../../../../../redux/slices/companyDashboardSlice";
import cn from "classnames";
import Button from "../../../../../components/Buttons/button";
import Pill from "../../../../Pill/pill";
import BasicModal from "../../../../models/models";
import Unicon from "../../../../../assets/images/arrow-down-circle.svg";
import Search from "../../../../../assets/images/search.png";

const Integration = ({ service_id }) => {
  const dispatch = useDispatch();
  const companyState = useSelector(selectCompanyDashboard);
  const { newIntegrationData, serviceIntegrations } = companyState;
  const [popup, setPopup] = useState(false);
  const [state, setState] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [sortOrder, setSortOrder] = useState("asc");
  const [sortedIntegrations, setSortedIntegrations] = useState([]);
  const [integrationUpdated, setIntegrationUpdated] = useState(false);
  const [selectedIntegration, setSelectedIntegration] = useState(null);

  const displayIntegrations = sortedIntegrations?.filter((integration) =>
    integration.service_name.toLowerCase().includes(searchTerm.toLowerCase())
  );
  useEffect(() => {
    dispatch(getServiceIntegrations(service_id));
  }, [dispatch, getServiceIntegrations, service_id, newIntegrationData]);

  useEffect(() => {
    if (serviceIntegrations?.integrations) {
      setSortedIntegrations([...serviceIntegrations?.integrations]);
    }
  }, [serviceIntegrations]);

  useEffect(() => {
    if (integrationUpdated) {
      setIntegrationUpdated(false);
      setSelectedIntegration(null);
      setState(62);
    }
  }, [integrationUpdated]);

  const handleSortName = () => {
    const sorted = [...serviceIntegrations?.integrations].sort((a, b) => {
      if (sortOrder === "asc") {
        return a.service_name.localeCompare(b.service_name);
      } else {
        return b.service_name.localeCompare(a.service_name);
      }
    });
    setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    setSortedIntegrations(sorted);
  };

  const handleSortStatus = () => {
    const sorted = [...serviceIntegrations?.integrations].sort((a, b) => {
      if (sortOrder === "asc") {
        return a.status.localeCompare(b.status);
      } else {
        return b.status.localeCompare(a.status);
      }
    });
    setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    setSortedIntegrations(sorted);
  };

  const handleManage = (integration) => {
    setSelectedIntegration(integration);
    setPopup(true);
    setState(60);
    dispatch(setIntegrationCreatedFalse());
  };

  const statusMap = {
    in_process: "In process",
    completed: "Completed",
    pending: "Pending",
  };
  return (
    <div className="px-3 pt-3 md:px-4 md:pt-6 flex flex-col gap-[12px] md:gap-[24px]">
      <div className="searchBox mt-0 mx-0 md:mt-5 md:mx-4">
        <img src={Search} alt="icon" className="searchIcon" />
        <input
          type="text"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          placeholder="Search integrations"
          className="searchInput"
        />
      </div>
      <div className="w-[100%] !mt-0 scrollbar-hide scrollable_data">
        <div className="overflow-x-auto  overflow-y-auto scrollbar-hide">
          <table className="w-full whitespace-nowrap md:whitespace-initial">
            <thead className="table-head py-2 sticky top-0 bg-[#363D50]">
              <tr>
                <th
                  className={`text-left text-secondary border-[#434A5D] py-[12px] px-[4px] w-[400px]`}
                >
                  <Button
                    className="sorting_btn_wrapper"
                    secondaryHoverOutlined={true}
                    outlined={true}
                    onClick={handleSortName}
                  >
                    <span className="flex items-center text-[#A5AEBC]">
                      Integration
                      <img
                        className={cn("sortingicon", {
                          "rotate-180": sortOrder === "desc",
                        })}
                        src={Unicon}
                        alt="icon"
                      />
                    </span>
                  </Button>
                </th>
                <th
                  className={`text-left text-secondary border-[#434A5D] py-[12px] px-[8px]`}
                >
                  <Button
                    className="sorting_btn_wrapper"
                    secondaryHoverOutlined={true}
                    outlined={true}
                    onClick={handleSortStatus}
                  >
                    <span className="flex items-center text-[#A5AEBC]">
                      Status
                      <img
                        className={cn("sortingicon", {
                          "rotate-180": sortOrder === "desc",
                        })}
                        src={Unicon}
                        alt="icon"
                      />
                    </span>
                  </Button>
                </th>
                <th
                  className={`text-right text-secondary border-[#434A5D] py-[12px] px-[8px]`}
                >
                  &nbsp;
                </th>
              </tr>
            </thead>
            <tbody>
              {displayIntegrations?.map((integration) => (
                <tr key={integration.id}>
                  <td className="text-left text-secondary !text-[#FFFFFF] p-[16px]">
                    <div className="flex flex-col md:flex-row items-center gap-[10px]">
                      <div className="w-[40px] h-[40px] rounded-lg bg-[#242B3E] flex items-center justify-center">
                        <svg
                          width="32"
                          height="32"
                          viewBox="0 0 32 32"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M16.6648 11.9451C18.5577 11.6286 20.0003 9.98278 20.0003 8C20.0003 5.79086 18.2095 4 16.0003 4C13.7912 4 12.0003 5.79086 12.0003 8C12.0003 9.98278 13.443 11.6286 15.3359 11.9451C15.3344 11.9632 15.3337 11.9815 15.3337 12V15.2494H12.7509C10.1272 15.2494 8.00033 17.3763 8.00033 20C8.00033 20.0185 8.00108 20.0368 8.00256 20.0549C6.10965 20.3714 4.66699 22.0172 4.66699 24C4.66699 26.2091 6.45785 28 8.66699 28C10.8761 28 12.667 26.2091 12.667 24C12.667 22.0172 11.2243 20.3714 9.33143 20.0549C9.3329 20.0368 9.33366 20.0185 9.33366 20C9.33366 18.1127 10.8636 16.5827 12.7509 16.5827H19.2497C21.137 16.5827 22.667 18.1127 22.667 20C22.667 20.0185 22.6677 20.0368 22.6692 20.0549C20.7763 20.3714 19.3337 22.0172 19.3337 24C19.3337 26.2091 21.1245 28 23.3337 28C25.5428 28 27.3337 26.2091 27.3337 24C27.3337 22.0172 25.891 20.3714 23.9981 20.0549C23.9996 20.0368 24.0003 20.0185 24.0003 20C24.0003 17.3763 21.8734 15.2494 19.2497 15.2494H16.667V12C16.667 11.9815 16.6662 11.9632 16.6648 11.9451ZM16.0003 10.6667C17.4731 10.6667 18.667 9.47276 18.667 8C18.667 6.52724 17.4731 5.33333 16.0003 5.33333C14.5276 5.33333 13.3337 6.52724 13.3337 8C13.3337 9.47276 14.5276 10.6667 16.0003 10.6667ZM11.3337 24C11.3337 25.4728 10.1398 26.6667 8.66699 26.6667C7.19423 26.6667 6.00033 25.4728 6.00033 24C6.00033 22.5272 7.19423 21.3333 8.66699 21.3333C10.1398 21.3333 11.3337 22.5272 11.3337 24ZM26.0003 24C26.0003 25.4728 24.8064 26.6667 23.3337 26.6667C21.8609 26.6667 20.667 25.4728 20.667 24C20.667 22.5272 21.8609 21.3333 23.3337 21.3333C24.8064 21.3333 26.0003 22.5272 26.0003 24Z"
                            fill="white"
                          />
                        </svg>
                      </div>
                      <div className="flex flex-col">
                        <span className="text-secondary lineHeight !text-[#FFFFFF] !text-left !font-medium">
                          {integration.service_name}
                        </span>
                        <span className="text-secondary lineHeight !text-left">
                          {integration.integration_type_name}
                        </span>
                      </div>
                    </div>
                  </td>

                  <td className="text-left text-secondary !text-[#FFFFFF] pl-[20px] p-[16px] !font-medium font_12px">
                    <Pill greenFill={true}>
                      {" "}
                      {statusMap[integration.status]}{" "}
                    </Pill>
                  </td>
                  <td className="flex items-center justify-end text-secondary !text-[#FFFFFF] pl-[20px] p-[16px] !font-medium font_12px">
                    <Button
                      outlined={true}
                      hoverColor={true}
                      secondary={true}
                      secondaryHoverOutlined={true}
                      onClick={() => {
                        handleManage(integration);
                      }}
                    >
                      Manage
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      {popup && (
        <BasicModal
          state={state}
          popup={popup}
          setPopup={setPopup}
          setState={setState}
          selectedIntegration={selectedIntegration}
          setIntegrationUpdated={setIntegrationUpdated}
        />
      )}
    </div>
  );
};

export default Integration;
